<nav class="navbar navbar-light bg-light navbar-expand-lg">
  <div class="collapse navbar-collapse">
    <button [disabled]="bloquear" class="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <ul class="navbar-nav me-auto">
      <!--buscador -->
      <li class="nav-item me-2">
        <div class="nav-item">
          <input [disabled]="bloquear" id="busquedaFormControl" type="text" class="form-control"
                 [formControl]="busquedaFormControl" placeholder="Buscador" (input)="filtrarClientes()"/>
        </div>
      </li>
    </ul>
      @if(esAprobador && clientesSolicitudes) {
        <div class="float-end me-3">
          <button [disabled]="modificando || !haySelecciones" (click)="aprobarRechazarModificaciones(true)" class="btn btn-success">
            @if(!modificando) {
              Aprobar cambios
            } @else {
              <div class="d-flex align-items-center">
                <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                <span>Cargando...</span>
              </div>
            }
          </button>
        </div>
        <div class="float-end">
          <button [disabled]="modificando || !haySelecciones" (click)="aprobarRechazarModificaciones(false)" class="btn btn-danger">
            @if(!modificando) {
              Rechazar cambios
            } @else {
              <div class="d-flex align-items-center">
                <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                <span>Cargando...</span>
              </div>
            }
          </button>
        </div>
      }

  </div>
</nav>
<div class="col container-fluid">
  <form class="mb-3">
    <div class="col col-md-12">
      <div class="spinner-container" *ngIf="ocultarTabla">
        <ngx-spinner name="spinnerLista" bdOpacity=0.3bd
                     Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
          <p style="color: white"> C a r g a n d o . . . </p>
        </ngx-spinner>
      </div>
      <div *ngIf="clientesSolicitudes?.length != null && !ocultarTabla" id="scroll-infinito" class="tabla-solicitudesClientes">
        <table class="table table-responsive mt-3">
            @for (solicitud of clientesSolicitudes; track solicitud.id; let i = $index) {
              <thead class="text-center letra">
              <tr class="border-top-black">
                <th scope="col">Cliente</th>
                <th scope="col">Situaci&oacute;n anterior</th>
                <th scope="col">Situaci&oacute;n nueva</th>
                <th scope="col">Estado de la solicitud</th>
                <th scope="col">Acci&oacute;n</th>
              </tr>
              </thead>
               <tbody class="text-center letra mb-3">
                @if(solicitud.situacionVencido) {
                  <tr>
                    <td>{{ solicitud.razonSocial }}</td>
                    <td>{{ getDescripcionSituacion(solicitud.situacionVencido.situacionAnterior) }} por saldo vencido.</td>
                    <td>{{ getDescripcionSituacion(solicitud.situacionVencido.situacionActual) }} por saldo vencido.</td>
                    <td>{{ getDescripcionEstado(solicitud.situacionVencido.estado) }}</td>
                  @if(!esAprobador) {
                    <td>
                      <div style="justify-content: center" class="d-flex align-items-center fondo">
                        @if (!eliminandoPendiente[i]) {
                          <button type="button" [disabled]="bloquear" (click)="anularPendiente(i, solicitud, AccionEliminar.Vencido)"
                                  class="fondo" style="border-style: none;" ngbTooltip="Anular pendiente">
                            <i class="fa fa-trash fondo" style="transform: scale(1.5)"></i>
                          </button>
                        } @else {
                          <div class="d-flex align-items-center">
                            <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                            <span>Eliminando...</span>
                          </div>
                        }
                      </div>
                    </td>
                  } @else {
                    <td>
                      <input [disabled]="modificando" type="checkbox" class="form-check-input" (change)="checkboxSeleccionar($event.target.checked, solicitud, true)" />
                    </td>
                  }
                  </tr>
                }
                @if(solicitud.situacionExcedido) {
                  <tr>
                    <td>{{ solicitud.razonSocial }}</td>
                    <td>{{ getDescripcionSituacion(solicitud.situacionExcedido.situacionAnterior) }} por saldo excedido.</td>
                    <td>{{ getDescripcionSituacion(solicitud.situacionExcedido.situacionActual) }} por saldo excedido.</td>
                    <td>{{ getDescripcionEstado(solicitud.situacionExcedido.estado) }}</td>
                    @if(!esAprobador) {
                      <td>
                        <div style="justify-content: center" class="d-flex align-items-center fondo">
                          @if (!eliminandoPendiente[i]) {
                            <button type="button" [disabled]="bloquear" (click)="anularPendiente(i, solicitud, AccionEliminar.Excedido)"
                                    class="fondo" style="border-style: none;" ngbTooltip="Anular pendiente">
                              <i class="fa fa-trash fondo" style="transform: scale(1.5)"></i>
                            </button>
                          } @else {
                            <div class="d-flex align-items-center">
                              <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                              <span>Eliminando...</span>
                            </div>
                          }
                        </div>
                      </td>
                    } @else {
                      <td>
                        <input [disabled]="modificando" type="checkbox" class="form-check-input" (change)="checkboxSeleccionar($event.target.checked, solicitud, false)" />
                      </td>
                    }
                  </tr>
                }
               </tbody>
               <br>
            } @empty {
              <ngb-alert class="alert-warning mt-2">
                No hay registros pendientes
              </ngb-alert>
            }
        </table>
      </div>
    </div>
  </form>
</div>
